import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", dupr_rating: 3.5, location: "Charlotte, NC" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Welcome to the PaddleVerse. Kitchen infractions: zero.");
      nav("/home");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen pv-bg-neutral flex items-center justify-center p-4">
      <div className="w-full max-w-md card p-6 sm:p-8 rise-in">
        <div className="mb-6"><Logo /></div>
        <h2 className="text-2xl font-display font-extrabold pv-text-dark">Create your Passport</h2>
        <p className="text-sm text-gray-600 mt-1">Let's get your dink together.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label>Name</Label>
            <Input data-testid="register-name" required value={form.name} onChange={(e)=>setForm(f=>({...f,name:e.target.value}))} placeholder="Your name"/>
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="register-email" required type="email" value={form.email} onChange={(e)=>setForm(f=>({...f,email:e.target.value}))} placeholder="you@example.com"/>
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="register-password" required type="password" value={form.password} onChange={(e)=>setForm(f=>({...f,password:e.target.value}))} placeholder="At least 6 chars"/>
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label>DUPR-style rating</Label>
              <span className="pill pv-bg-primary text-black" data-testid="rating-value">{form.dupr_rating.toFixed(1)}</span>
            </div>
            <Slider min={2} max={6} step={0.1} value={[form.dupr_rating]} onValueChange={(v)=>setForm(f=>({...f,dupr_rating:v[0]}))} className="mt-3" data-testid="rating-slider"/>
            <div className="flex justify-between text-xs text-gray-500 mt-1"><span>2.0</span><span>3.5</span><span>5.0</span><span>6.0</span></div>
          </div>
          <div>
            <Label>Home city</Label>
            <Input data-testid="register-location" value={form.location} onChange={(e)=>setForm(f=>({...f,location:e.target.value}))}/>
          </div>

          <button type="submit" disabled={busy} data-testid="register-submit-btn" className="btn-primary w-full disabled:opacity-70">
            {busy ? <Loader2 className="mx-auto animate-spin" size={18}/> : "Get your paddle in"}
          </button>
        </form>

        <p className="text-sm text-center mt-6 text-gray-600">
          Already playing? <Link to="/login" className="font-bold pv-text-support" data-testid="go-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
